<template>
  <div class="flex lg:flex-row flex-col gap-10">
    <div class="flex flex-col">
      <app-itineraries :itineraries="itineraries" :itinerary-selected="itinerarySelected">
        <button v-for="(option, index) in itineraries" :key="index" @click="itinerarySelected = index" class="rounded-xlg py-2 px-5 mr-4 btn-day font-bold w-full" :class="{ 'bg-navy text-white': itinerarySelected === index }">
          {{ option.days }}
          {{$t('days')}}
        </button>
      </app-itineraries>

      <app-itinerary-detail>
        <div class="flex lg:flex-row flex-col items-start gap-10 ">
          <app-itineraries :itineraries="itineraries" detailed :itinerary-selected="itinerarySelected" :landing="landing">
            <button v-for="(option, index) in itineraries" :key="index" @click="itinerarySelected = index" class="rounded-xlg py-2 px-5 mr-4 btn-day font-bold" :class="{ 'bg-navy text-white': itinerarySelected === index }">{{ option.days }}
              {{$t('days')}}
            </button>
          </app-itineraries>
          <div class="lg:sticky lg:top-8 w-full">
            <img :src="itineraryImage" :alt="getSelectedItineraryAlt" class="rounded-xlg w-full">
          </div>
        </div>
      </app-itinerary-detail>
    </div>
    <div>
      <img :src="itineraryImage" :alt="getSelectedItineraryAlt" class="w-full rounded-xlg max-w-[600px]">
    </div>
  </div>
</template>

<script>
import ItineraryDetail from "./ItineraryDetail.vue";
import Itineraries from "./Itineraries.vue";

export default {
  props: {
    itineraries: {
      type: Array,
      required: true
    },
    itineraryImage: {
      type: String,
      required: true,
    },
    updateSelected: {
      type: Function,
      required: true,
    },
    landing: {
      type: Object,
    }
  },
  data() {
    return {
      itinerarySelected: 0,
      destination: this.$route.name
    }
  },
  components: {
    'app-itinerary-detail': ItineraryDetail,
    'app-itineraries': Itineraries
  },
  mounted() {
    this.$watch('itinerarySelected', (newValue, oldValue) => {
      this.updateSelected(newValue);
    });
  },
  computed: {
    getSelectedItineraryAlt() {
      const selectedItinerary = this.itineraries[this.itinerarySelected];
      return selectedItinerary ? selectedItinerary.alt : '';
    }
  },
  created() {
    this.destination = this.$route.path;
  },
}
</script>
<style lang="scss">
 .btn-day {
  border: 1px solid black;
   @media screen and (min-width: 992px) {
    width: 120px;
  }
 }
</style>

